<app-select
  [id]="id()"
  [items]="selectItems()"
  [value]="value()"
  (valueChange)="onSelection($any($event))"
  (touchedChange)="onTouched()" />
